import styled from '@emotion/styled';
import { colors } from '@libs/ui';
import ArrowDropDown from '@mui/icons-material/ArrowDropDown';
import ArrowDropUp from '@mui/icons-material/ArrowDropUp';
import DescriptionOutlined from '@mui/icons-material/DescriptionOutlined';
import { HeaderControlGroupItem } from '../../../components';

const StyledButton = styled(HeaderControlGroupItem)`
  max-width: 160px;
  padding: 0 2px 0 10px;
`;

const SpaceName = styled.span`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  min-width: 0;
`;

const Count = styled.span`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  min-width: 15px;
  height: 15px;
  padding: 0 3px;
  border-radius: 8px;
  background-color: ${colors.deepGray};
  color: ${colors.txtBlack};
  font-size: 11px;
  font-weight: 700;
`;

interface SpaceButtonProps {
  spaceName: string;
  spaceCount: number;
  anchorEl: HTMLElement | null;
  setAnchorEl: (el: HTMLElement | null) => void;
}

function SpaceButton(props: SpaceButtonProps) {
  const { spaceName, spaceCount, anchorEl, setAnchorEl } = props;

  return (
    <StyledButton type="button" title={spaceName} onClick={(e) => setAnchorEl(e.currentTarget)}>
      <DescriptionOutlined
        sx={{ fontSize: '14px', color: colors.txtBlack, marginRight: '2px', flexShrink: 0 }}
      />
      <SpaceName>{spaceName}</SpaceName>
      <Count>{spaceCount}</Count>
      {anchorEl ? (
        <ArrowDropUp fontSize="small" sx={{ flexShrink: 0 }} />
      ) : (
        <ArrowDropDown fontSize="small" sx={{ flexShrink: 0 }} />
      )}
    </StyledButton>
  );
}

export { SpaceButton };
